module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl2-75.511f0a73.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-B-lvl2-75.png
// module id = 3382
// module chunks = 11